import { OtelFieldCategory } from '@logz-pkg/enums';
/**
 * Explicit OTEL -> Jaeger field mappings. The registry grows as the filter
 * pane and additional OTEL semantic-convention fields are onboarded.
 *
 * Unregistered fields fall back to a dynamic rule:
 *   OTEL  'x.y.z'              <->  Jaeger 'JaegerTag.x@y@z'
 * (see otel-field-to-jaeger.util.ts)
 */
export const OTEL_JAEGER_FIELD_REGISTRY = {
    'service.name': { jaeger: 'process.serviceName', category: OtelFieldCategory.Service },
    'http.request.method': { jaeger: 'JaegerTag.http@request@method', category: OtelFieldCategory.HTTP },
    'http.response.status_code': {
        jaeger: 'JaegerTag.http@response@status_code',
        category: OtelFieldCategory.HTTP,
        legacyAliases: ['http.status_code'],
    },
    'http.route': { jaeger: 'JaegerTag.http@route', category: OtelFieldCategory.HTTP },
    'http.url': { jaeger: 'JaegerTag.http@url', category: OtelFieldCategory.HTTP },
    'span.name': { jaeger: 'operationName', category: OtelFieldCategory.Span },
    'span.id': { jaeger: 'spanID', category: OtelFieldCategory.Span },
    'span.kind': { jaeger: 'JaegerTag.span@kind', category: OtelFieldCategory.Span },
    'span.duration': { jaeger: 'duration', category: OtelFieldCategory.Span },
    'trace.id': { jaeger: 'traceID', category: OtelFieldCategory.Trace },
    'otel.status_code': { jaeger: 'JaegerTag.otel@status_code', category: OtelFieldCategory.Span },
    env: { jaeger: 'JaegerTag.env', category: OtelFieldCategory.Service },
    env_id: { jaeger: 'JaegerTag.env_id', category: OtelFieldCategory.Service },
    'k8s.namespace.name': {
        jaeger: 'process.tag.kubernetes_namespace',
        category: OtelFieldCategory.Service,
        legacyAliases: ['kubernetes_namespace', 'kubernetes.namespace', 'kubernetes.namespace_name', 'k8s_namespace_name'],
    },
    'k8s.pod.name': {
        jaeger: 'process.tag.pod',
        category: OtelFieldCategory.Service,
        legacyAliases: ['pod', 'kubernetes.pod_name', 'pod-name', 'k8s_pod_name'],
    },
    'k8s.pod.uid': {
        jaeger: 'process.tag.kubernetes_pod_uid',
        category: OtelFieldCategory.Service,
        legacyAliases: ['kubernetes_pod_uid', 'kubernetes.pod_uid', 'kubernetes.pod_id', 'k8s_pod_uid'],
    },
    'k8s.pod.ip': {
        jaeger: 'process.tag.kubernetes_pod_ip',
        category: OtelFieldCategory.Service,
        legacyAliases: ['kubernetes_pod_ip', 'kubernetes.pod_ip', 'pod_ip', 'k8s_pod_ip'],
    },
    'k8s.node.name': {
        jaeger: 'process.tag.kubernetes_node',
        category: OtelFieldCategory.Service,
        legacyAliases: ['kubernetes_node', 'kubernetes.node', 'kubernetes.host', 'k8s_node_name'],
    },
    'k8s.deployment.name': {
        jaeger: 'process.tag.kubernetes_deployment',
        category: OtelFieldCategory.Service,
        legacyAliases: [
            'kubernetes_deployment',
            'kubernetes.deployment',
            'kubernetes.deployment_name',
            'k8s_deployment_name',
        ],
    },
    'k8s.daemonset.name': {
        jaeger: 'process.tag.kubernetes_daemonset',
        category: OtelFieldCategory.Service,
        legacyAliases: ['kubernetes_daemonset', 'kubernetes.daemonset', 'kubernetes.daemonset_name', 'k8s_daemonset_name'],
    },
    'k8s.statefulset.name': {
        jaeger: 'process.tag.kubernetes_statefulset',
        category: OtelFieldCategory.Service,
        legacyAliases: [
            'kubernetes_statefulset',
            'kubernetes.statefulset',
            'kubernetes.statefulset_name',
            'k8s_statefulset_name',
        ],
    },
    'k8s.replicaset.name': {
        jaeger: 'process.tag.kubernetes_replicaset',
        category: OtelFieldCategory.Service,
        legacyAliases: ['kubernetes_replicaset', 'kubernetes.replicaset'],
    },
    'k8s.job.name': {
        jaeger: 'process.tag.kubernetes_job',
        category: OtelFieldCategory.Service,
        legacyAliases: ['kubernetes_job', 'kubernetes.job'],
    },
    'k8s.rollout.name': {
        jaeger: 'process.tag.kubernetes_rollout',
        category: OtelFieldCategory.Service,
        legacyAliases: ['kubernetes_rollout', 'kubernetes.rollout'],
    },
    'k8s.container.name': {
        jaeger: 'process.tag.kubernetes_container',
        category: OtelFieldCategory.Service,
        legacyAliases: ['kubernetes_container', 'kubernetes.container', 'kubernetes.container_name', 'k8s_container_name'],
    },
    'host.name': { jaeger: 'JaegerTag.host@name', category: OtelFieldCategory.Service },
    'host.id': { jaeger: 'JaegerTag.host@id', category: OtelFieldCategory.Service },
    'host.type': { jaeger: 'JaegerTag.host@type', category: OtelFieldCategory.Service },
    'host.arch': { jaeger: 'JaegerTag.host@arch', category: OtelFieldCategory.Service },
    'host.ip': { jaeger: 'JaegerTag.host@ip', category: OtelFieldCategory.Service },
    'host.image.name': { jaeger: 'JaegerTag.host@image@name', category: OtelFieldCategory.Service },
    'host.image.id': { jaeger: 'JaegerTag.host@image@id', category: OtelFieldCategory.Service },
    'host.image.version': { jaeger: 'JaegerTag.host@image@version', category: OtelFieldCategory.Service },
};
//# sourceMappingURL=otel-jaeger-field-registry.js.map